import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { Section, Heading, Image, Testimonial } from 'components';
import './ClientReview.scss';

const ClientReview = ({ data, mainColor }) => {
  const { testimonial, author, image, alt } = data;

  return (
    <Section spaceless fullwidth side={'left'}>
      <Row className={'no-gap'}>
        <Col
          sm={12}
          md={6}
          className={`client-review__container client-review__container--${mainColor}`}
        >
          <div className={'section w-container--left'}>
            <Heading
              size={'medium'}
              color={'white'}
              type={3}
              additionalClass={
                'text--default client-review__testimonial-intro'
              }
            >
              Clients review
            </Heading>
            <Testimonial
              content={testimonial}
              author={author}
              additionalClass={'text--light'}
            />
          </div>
        </Col>
        <Col sm={12} md={6} className={'client-review__image-wrapper'}>
          <div className={'client-review__image'}>
            <Image src={image} alt={alt} />
          </div>
        </Col>
      </Row>
    </Section>
  );
};

ClientReview.defaultProps = {
  alt: '',
  mainColor: 'yellow',
};

ClientReview.propTypes = {
  data: PropTypes.shape({
    testimonial: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    alt: PropTypes.string,
    mainColor: PropTypes.string,
  }).isRequired,
};

export default ClientReview;
